import { render, staticRenderFns } from "./insurer-summary.vue?vue&type=template&id=7514ded8&scoped=true"
import script from "./insurer-summary.vue?vue&type=script&lang=js"
export * from "./insurer-summary.vue?vue&type=script&lang=js"
import style0 from "./insurer-summary.vue?vue&type=style&index=0&id=7514ded8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7514ded8",
  null
  
)

export default component.exports